<div class="multi-formular-snack-bar">
    <ng-container>
        <div class="multi-formular-snack-bar__content">
            <div class="multi-formular-snack-bar__content__message">
                <h1 class="text-h2">Bereits offenes Formular</h1>
                <p class="text-plain">Dieses Formular ist bereits in diesem Browser geöffnet. Bitte wechseln sie zu dem entsprechenden Fenster.</p>
            </div>
            <app-button
                class="multi-formular-snack-bar__content__button"
                [isButton]="true"
                buttonLabel="Hinweis schließen"
                (clickEvent)="cancleClick()"></app-button>
        </div>
    </ng-container>
</div>
